<div class="price-forecast">
	<span class="title">{{ 'priceForecast.title' | translate }}</span>

	@let prices = priceTarget()?.price_target;

	<div class="inner">
		<div class="prices">
			<div class="item">
				<span class="title">{{ 'priceForecast.maxPrice' | translate }}:</span>
				<div
					class="value"
					[tuiSkeleton]="isLoadingPriceTarget()"
				>
					<span
						class="dollar"
						highlight
						[isPositive]="true"
					>
						{{ prices?.high | price: false }}
					</span>
					<span
						class="percent"
						highlight
						[isPositive]="true"
					>
						{{ getPercent(prices?.high) | profit: 'percent' }}
					</span>
				</div>
			</div>

			<div class="divider"></div>

			<div class="item">
				<span class="title">{{ 'priceForecast.avgPrice' | translate }}:</span>
				<div
					class="value"
					[tuiSkeleton]="isLoadingPriceTarget()"
				>
					<span class="dollar">
						{{ prices?.average | price: false }}
					</span>
					<span class="percent">
						{{ getPercent(prices?.average) | profit: 'percent' }}
					</span>
				</div>
			</div>

			<div class="divider"></div>

			<div class="item">
				<span class="title">{{ 'priceForecast.minPrice' | translate }}:</span>
				<div
					class="value"
					[tuiSkeleton]="isLoadingPriceTarget()"
				>
					<span
						class="dollar"
						highlight
						[isNegative]="true"
					>
						{{ prices?.low | price: false }}
					</span>
					<span
						class="percent"
						highlight
						[isNegative]="true"
					>
						{{ getPercent(prices?.low) | profit: 'percent' }}
					</span>
				</div>
			</div>
		</div>

		<span
			class="description"
			[tuiSkeleton]="isLoadingRecommendations() && isLoadingPriceTarget()"
		>
			{{
				'priceForecast.description'
					| translate
						: {
								symbol: recommendations()?.meta?.symbol ?? this.liveTicker()?.ticker,
								count: totalAnalysts(),
								minPrice: priceTarget()?.price_target?.low,
								maxPrice: priceTarget()?.price_target?.high,
						  }
			}}
		</span>

		<div
			#chart
			class="chart"
		>
			@if (isLoadingPriceTarget() || isLoadingBars()) {
				<div
					[tuiSkeleton]="true"
					class="chart-skeleton"
				></div>
			}
		</div>
	</div>
</div>
